
<template>
  <v-app>
    <v-app-bar
      class="elevation-0"
      color="#AB0520"
      style="height: 64px; padding: 0px 16px"
    >
          <!-- v-if="!getIsMobile" -->

      <a
        href="https://www.arizona.edu"
        title="The University of Arizona homepage"
        class="arizona-logo remove-external-link-icon"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          alt="The University of Arizona Wordmark Line Logo White"
          src="https://cdn.uadigital.arizona.edu/logos/v1.0.0/ua_wordmark_line_logo_white_rgb.min.svg"
          class="arizona-line-logo"
        />
      </a>
    </v-app-bar>

    <PageWrapper v-if="isMounted"></PageWrapper>
  </v-app>
</template>

<script>
import PageWrapper from "./components/PageWrapper.vue";
import { useHead } from "@vueuse/head";
// import { mapState, mapGetters } from "vuex";
import { mapMutations, mapState, mapGetters} from "vuex";

export default {
  name: "App",
  components: {
    PageWrapper,
  },
  data() {
    return {
      isMounted: false, // Flag to control PageWrapper rendering
    };
  },
  mounted() {
    console.log("Mounted .... ")
    this.updateHead();
    if (/Android|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        //deviceType = "mobile";
        this.SET_IS_MOB(true);
        // console.log("MObile True")
      }

      // Set the flag to true once all logic is done
    this.isMounted = true;
  },
  methods: {
    updateHead() {
      useHead({
        meta: [
          {
            name: "viewport",
            // content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no '
            content: 'width=device-width, initial-scale=1.0, user-scalable=no'
            // content:
              // "width=device-width, initial-scale=1",
              // 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no '
          },
        ],
      });
    },
    ...mapMutations(["SET_IS_MOB"]),
  },
  computed: {
    ...mapState([]),
    ...mapGetters(["getIsMobile"]),
  },
};
</script>
<style>
/* Disable drag */
* {
  touch-action: manipulation;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-drag: none; /* Safari, Chrome */
  -khtml-user-drag: none; /* Konqueror */
  -moz-user-drag: none; /* Firefox */
  -o-user-drag: none; /* Opera */
}

html {
  /* overflow: auto !important; */
  overscroll-behavior: none;
  overflow: hidden !important;
}
html,
body {
  width: 100;
  height: 100%;
  padding: 0;
  margin: 0;
}

* {
  touch-action: manipulation;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100;
  height: 100%;
  padding: 0;
  margin: 0;
}
.arizona-logo {
  display: inline-block;
  height: 20px;
  margin: 25px 0 20px;
  max-width: 80%;
  float: left;
  width: 276px;
  padding: 0 0 0 0.6rem;
}

/* 52.5px */
</style>